module.exports = __webpack_public_path__ + "image/service-banner.jpg";